// extracted by mini-css-extract-plugin
export default {"quotation2":"Quotation2_quotation2__g1c5k"};